import { createRouterMiddleware } from '@lagunovsky/redux-react-router';
import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import logger from 'redux-logger';
import { createEpicMiddleware } from 'redux-observable';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { REACT_APP_NAME } from '../../config/Config';
import rootReducer from './Reducers';

// 🔹 1. Crear history
export const history = createBrowserHistory();

// 🔹 2. Middleware de redux-observable
const epicMiddleware = createEpicMiddleware();

// 🔹 3. DevTools setup
const composeEnhancers =
  (typeof window === 'object' &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

// 🔹 4. Middleware de router
const routerMiddleware = createRouterMiddleware(history);

// 🔹 5. Persistencia
const persistConfig = {
  key: `root_${REACT_APP_NAME}`,
  storage,
};

// 🔹 6. Reducer con persistencia
const persistedReducer = persistReducer(
  persistConfig,
  rootReducer(history) // 👈 tu rootReducer ya recibe el history y combina todo internamente
);

// 🔹 7. Store + middlewares
const enhancer = composeEnhancers(
  process.env.NODE_ENV === 'development'
    ? applyMiddleware(epicMiddleware, routerMiddleware, logger as any)
    : applyMiddleware(epicMiddleware, routerMiddleware)
);

export const store = createStore(persistedReducer, enhancer);
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
